export default "__VITE_ASSET__BWLXX55s__"